import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { InvitationStatus, InvitationStatuses } from 'globals/types';

export interface SingleInvitationProps {
  id: number;
  name: string;
  email: string;
  code: string;
  statusType: InvitationStatus;
  date: number;
  invitedBy?: string;
}

export const SingleInvitation = types.model({
  id: types.number,
  name: types.string,
  email: types.string,
  code: types.string,
  statusType: types.optional(
    types.enumeration(InvitationStatuses),
    InvitationStatus.SENT
  ),
  date: types.number,
  invitedBy: types.maybe(types.string),
});

export type SingleInvitationSnapshot = SnapshotIn<typeof SingleInvitation>;
export type SingleInvitationInstance = Instance<typeof SingleInvitation>;
